import React from "react";
import "chart.js/auto";
import Spinner from "../../components/Spinner/Spinner";
import scrollToHash from "../../utils/scrollToHash";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import TokoTidakAktif from "../../components/TokoTidakAktif/TokoTidakAktif";
import moment from "moment";
import "moment/locale/id";
import Box from "@mui/material/Box";
import LaporanInactiveView from "./components/LaporanInactiveView";
import LaporanMainContent from "./components/LaporanMainContent";
import LaporanModals from "./components/LaporanModals";
import useLaporanErrorToast from "./hooks/useLaporanErrorToast";
import useLaporanPageData from "./hooks/useLaporanPageData";
import useLaporanViewState from "./hooks/useLaporanViewState";

moment.locales();
moment.locale("id");

const Laporan = () => {
    const theme = useTheme();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const isTabletScreen = useMediaQuery(theme.breakpoints.between("sm", "md"));
    const isLaptopScreen = useMediaQuery(theme.breakpoints.up("lg"));
    const {
        changeTab,
        closeModalAlertPro,
        closeModalPrintTutupBuku,
        closeModalUnduhLaporan,
        closeTooltipProdukTerjual,
        closeTooltipTotalPendapatan,
        closeTooltipTotalTransaksi,
        endDate,
        handleDateRangeChange,
        handleTabChange,
        isOpenModalAlertPro,
        isOpenModalPrintTutupBuku,
        isOpenModalUnduhLaporan,
        now,
        nowK,
        openModalAlertPro,
        openModalPrintTutupBuku,
        openModalUnduhLaporan,
        openTooltipProdukTerjual,
        openTooltipTotalPendapatan,
        openTooltipTotalTransaksi,
        startDate,
        tabSlug,
        tanggalAkhir,
        tanggalAwal,
        today,
        toggleTooltipProdukTerjual,
        toggleTooltipTotalPendapatan,
        toggleTooltipTotalTransaksi,
    } = useLaporanViewState();
    const {
        apiExportLaporan,
        chartData,
        chartOptions,
        hasNoAccess,
        isError,
        isLoadingGrafikPenjualan,
        isLoadingLaporanLabaRugi,
        isLoadingLaporanTotal,
        isLoadingUser,
        isUkmTidakAktif,
        laporanLabaRugi,
        laporanTotal,
        noWaAdmin,
        paramsLaporanTotal,
        ukmData,
        user,
    } = useLaporanPageData({
        tanggalAwal,
        tanggalAkhir,
    });

    useLaporanErrorToast(isError);

    React.useEffect(() => {
        scrollToHash();
    }, []);

    if (isLoadingUser) {
        return (
            <Box
                position="relative"
                height={isLaptopScreen ? "100vh" : "calc(100vh - 56px)"}
            >
                <Spinner />
            </Box>
        );
    }

    if (hasNoAccess) {
        return <TokoTidakAktif label="Anda tidak memiliki akses halaman ini" />;
    }

    if (ukmData && isUkmTidakAktif) {
        return (
            <LaporanInactiveView
                apiExportLaporan={apiExportLaporan}
                endDate={endDate}
                isPhoneScreen={isPhoneScreen}
                isTabletScreen={isTabletScreen}
                noWaAdmin={noWaAdmin}
                onDateRangeChange={handleDateRangeChange}
                startDate={startDate}
                tanggalAkhir={paramsLaporanTotal.tanggalAkhir}
                tanggalAwal={paramsLaporanTotal.tanggalAwal}
                today={today}
                ukmData={ukmData}
                user={user}
            />
        );
    }

    return (
        <Box>
            <Box>
                <LaporanMainContent
                    chartData={chartData}
                    chartOptions={chartOptions}
                    changeTab={changeTab}
                    closeTooltipProdukTerjual={closeTooltipProdukTerjual}
                    closeTooltipTotalPendapatan={closeTooltipTotalPendapatan}
                    closeTooltipTotalTransaksi={closeTooltipTotalTransaksi}
                    endDate={endDate}
                    handleDateRangeChange={handleDateRangeChange}
                    handleTabChange={handleTabChange}
                    isLoadingGrafikPenjualan={isLoadingGrafikPenjualan}
                    isLoadingLaporanLabaRugi={isLoadingLaporanLabaRugi}
                    isLoadingLaporanTotal={isLoadingLaporanTotal}
                    isPhoneScreen={isPhoneScreen}
                    isTabletScreen={isTabletScreen}
                    laporanLabaRugi={laporanLabaRugi}
                    laporanTotal={laporanTotal}
                    now={now}
                    onOpenModalAlertPro={openModalAlertPro}
                    onOpenModalPrintTutupBuku={openModalPrintTutupBuku}
                    onOpenModalUnduhLaporan={openModalUnduhLaporan}
                    openTooltipProdukTerjual={openTooltipProdukTerjual}
                    openTooltipTotalPendapatan={openTooltipTotalPendapatan}
                    openTooltipTotalTransaksi={openTooltipTotalTransaksi}
                    startDate={startDate}
                    tanggalAkhir={paramsLaporanTotal.tanggalAkhir}
                    tanggalAwal={paramsLaporanTotal.tanggalAwal}
                    today={today}
                    toggleTooltipProdukTerjual={toggleTooltipProdukTerjual}
                    toggleTooltipTotalPendapatan={toggleTooltipTotalPendapatan}
                    toggleTooltipTotalTransaksi={toggleTooltipTotalTransaksi}
                    ukmData={ukmData}
                    user={user}
                    tabSlug={tabSlug}
                />
                <LaporanModals
                    closeModalAlertPro={closeModalAlertPro}
                    closeModalPrintTutupBuku={closeModalPrintTutupBuku}
                    closeModalUnduhLaporan={closeModalUnduhLaporan}
                    isOpenModalAlertPro={isOpenModalAlertPro}
                    isOpenModalPrintTutupBuku={isOpenModalPrintTutupBuku}
                    isOpenModalUnduhLaporan={isOpenModalUnduhLaporan}
                    nowK={nowK}
                    paramsLaporanTotal={paramsLaporanTotal}
                    ukmData={ukmData}
                    user={user}
                />
            </Box>
        </Box>
    );
};

export default Laporan;
